import axios from 'axios';
import { showAlert } from '@/lib/utils';

const axiosApi = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 10000000,
});

// Request interceptor
axiosApi.interceptors.request.use((config) => {
    let lang = localStorage.getItem('x-lang');
    if (!lang) {
        localStorage.setItem('x-lang', 'id');
        lang = 'id';
    }

    const token = localStorage.getItem('auth_token');

    config.headers = {
        'X-LANG': lang,
        'X-KEY': process.env.VUE_APP_KEY,
        ...config.headers,
    };

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

// Response interceptor
axiosApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const statusCode = error.response.status
            const message = error.response.data?.message

            if (statusCode === 503) {
                showAlert(message, 'warning', '')
            }
        }
        return Promise.reject(error);
    },
);

export default axiosApi;
